const ratgeber = function () {
  setTimeout(function () {
    setupCollapse();
  }, 500);

  function setupCollapse() {
    $('#accordion').on('shown.bs.collapse', function () {
      let currentOpenPosTop = $('.card-header[aria-expanded="true"]').offset()
        .top;
      console.log(currentOpenPosTop);
      $('body, html').animate({
        scrollTop: currentOpenPosTop - $('header').outerHeight(),
      });
    });
  }
};

export default ratgeber;



// WEBPACK FOOTER //
// ./scripts/barba-views/ratgeber.js